import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "health-suite" }
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = { class: "d-flex justify-center navigation-buttons" }
const _hoisted_4 = { class: "button-wrapper position-relative" }
const _hoisted_5 = { class: "button-wrapper position-relative" }

import { ref, onMounted, computed, provide } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useSettingsStore } from '@/api/store/settings';

type RefreshFunction = () => void;

export default /*@__PURE__*/_defineComponent({
  __name: 'HealthSuiteView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const settingsStore = useSettingsStore();
const currentTab = ref('calendar');

const activeButtonStyle = computed(() => ({
  background: `linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), ${settingsStore.settings.primaryColor}`,
  color: 'white'
}));

const refreshCalendar = ref<RefreshFunction>(() => { /* intentionally empty */ });
provide('refreshCalendar', refreshCalendar);

const handleCalendarClick = () => {
  if (currentTab.value === 'calendar') {
    refreshCalendar.value();
  } else {
    navigateTo('calendar');
  }
};

const navigateTo = (tab: string) => {
  currentTab.value = tab;
  router.push({ name: `health-suite-${tab}` });
};

onMounted(() => {
  // Set initial tab based on route
  const routeName = route.name as string;
  if (routeName.includes('tracker')) {
    currentTab.value = 'tracker';
  } else {
    currentTab.value = 'calendar';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            class: _normalizeClass([{ 'active-tab': currentTab.value === 'calendar' }, "curved-button me-2"]),
            style: _normalizeStyle(currentTab.value === 'calendar' ? activeButtonStyle.value : {}),
            onClick: handleCalendarClick,
            elevation: "0",
            height: "40"
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createTextVNode(" My Calendar ", -1)),
              (currentTab.value === 'calendar')
                ? (_openBlock(), _createBlock(_component_v_badge, {
                    key: 0,
                    color: "error",
                    dot: "",
                    floating: "",
                    location: "top end"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class", "style"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_btn, {
            class: _normalizeClass([{ 'active-tab': currentTab.value === 'tracker' }, "curved-button ms-2"]),
            style: _normalizeStyle(currentTab.value === 'tracker' ? activeButtonStyle.value : {}),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('tracker'))),
            elevation: "0",
            height: "40"
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createTextVNode(" My Tracker ", -1)),
              (currentTab.value === 'tracker')
                ? (_openBlock(), _createBlock(_component_v_badge, {
                    key: 0,
                    color: "error",
                    dot: "",
                    floating: "",
                    location: "top end"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class", "style"])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})